import { Validator } from '../../types/Validator';

const errorCode = 'INVALID_CAR_PLATE';

const OLD_FORMAT = /[a-zA-Z]{2}-?\d{4}/;
const CURRENT_FORMAT = /[bcdfghjklprstvwxyzBCDFGHJKLPRSTVWXYZ]{4}-?\d{2}$/;

const validateCarPlate: Validator = value => {
  const plate = String(value);
  const isValid = CURRENT_FORMAT.test(plate) || OLD_FORMAT.test(plate);
  return value === undefined || isValid ? undefined : { errorCode };
};

export { errorCode, validateCarPlate };
